module.exports = __webpack_public_path__ + "img/울산역.cfaa8dce.webp";